import { IconProps } from '.';

const SearchIcon = ({
  color = 'var(--color-ui-icon-primary)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 10.75C3.5 6.74594 6.74594 3.5 10.75 3.5C14.7541 3.5 18 6.74594 18 10.75C18 14.7541 14.7541 18 10.75 18C6.74594 18 3.5 14.7541 3.5 10.75ZM10.75 2C5.91751 2 2 5.91751 2 10.75C2 15.5825 5.91751 19.5 10.75 19.5C12.896 19.5 14.8615 18.7275 16.3837 17.4453L20.7188 21.7804L21.7794 20.7197L17.4444 16.3848C18.7271 14.8624 19.5 12.8965 19.5 10.75C19.5 5.91751 15.5825 2 10.75 2Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
